import { Or, Rule, StringEquals } from '@vendasta/automata';
import { RulePath } from './consts';

// LastEditActionCondition are Options for the radio select in the UI
export enum LastEditActionCondition {
  CreatedOrUpdated = 'CreatedOrUpdated',
  Closed = 'UpdatePipelineStage',
  Create = 'Create',
  UpdateProbability = 'UpdateProbability',
}

const createdOrUpdatedRule = new Or(
  [
    new StringEquals(RulePath.lastEditActionPath, LastEditActionCondition.UpdateProbability, ''),
    new StringEquals(RulePath.lastEditActionPath, LastEditActionCondition.Create, ''),
  ],
  '',
);

const createdRule = new StringEquals(RulePath.lastEditActionPath, LastEditActionCondition.Create, '');
const updatedRule = new StringEquals(RulePath.lastEditActionPath, LastEditActionCondition.UpdateProbability, '');
const closedRule = new StringEquals(RulePath.lastEditActionPath, LastEditActionCondition.Closed, '');

export function getRule(reason: LastEditActionCondition | string): Rule | undefined {
  switch (reason) {
    case LastEditActionCondition.CreatedOrUpdated:
      return createdOrUpdatedRule;
    case LastEditActionCondition.Closed:
      return closedRule;
    case LastEditActionCondition.Create:
      return createdRule;
    case LastEditActionCondition.UpdateProbability:
      return updatedRule;
    default:
      return undefined;
  }
}
